(function () {
  var FALLBACK_ID = 'sign-up-newsletter-fallback';
  var CHECK_DELAY_MS = 500;
  var FINAL_CHECK_MS = 3000;
  var checkTimer = null;
  var finalTimer = null;

  function getKlaviyoContainer() {
    return document.querySelector('[class*="klaviyo-form-"]');
  }

  function isKlaviyoFormRendered() {
    var container = getKlaviyoContainer();
    if (!container) return false;
    return !!container.querySelector('form, input[type="email"], .klaviyo-form-version-cid, [data-testid="klaviyo-form"]');
  }

  function checkFormState() {
    var fallback = document.getElementById(FALLBACK_ID);
    var container = getKlaviyoContainer();
    if (!fallback || !container) return;

    if (isKlaviyoFormRendered()) {
      fallback.hidden = true;
      container.style.display = '';
    } else {
      fallback.hidden = false;
      if (fallback.dataset.shown !== 'true') {
        fallback.dataset.shown = 'true';
        container.parentNode.insertBefore(fallback, container);
      }
      container.style.display = 'none';
    }
  }

  function scheduleCheck(delay) {
    if (checkTimer) clearTimeout(checkTimer);
    checkTimer = setTimeout(function () {
      checkFormState();
    }, delay || CHECK_DELAY_MS);
  }

  function init() {
    if (!getKlaviyoContainer()) return;

    scheduleCheck(CHECK_DELAY_MS);
    finalTimer = setTimeout(function () {
      checkFormState();
    }, FINAL_CHECK_MS);
  }

  document.addEventListener('PandectesInitialized', function () {
    scheduleCheck(CHECK_DELAY_MS);
  });
  document.addEventListener('PandectesConsentUpdate', function () {
    scheduleCheck(CHECK_DELAY_MS);
  });
  document.addEventListener('PandectesEvent_OnConsent', function () {
    scheduleCheck(CHECK_DELAY_MS);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
